import styled from 'styled-components';

const ClickableMiner = styled.div`
  display: flex;
  cursor: pointer;
  align-items: flex-start;
  font-size: 10px;
  opacity: 0.8;
  
  &:hover {
    opacity: 1;
  }
`;

export default ClickableMiner;
